import React, { useMemo } from "react";
import { getComparator, stableSort } from "../../../../libs/headerSortMethods";
import { RecruitmentLists } from "../Lists/RecruitmentLists";

function MemoizedList({
  data,
  loading,
  order,
  orderBy,
  isPage,
  rowsPerPage,
  isSelected,
  handleClick,
  isCheckbox,
  handleNoteRequest,
}) {
  return useMemo(() => {
    return (
      <RecruitmentLists
        data={data}
        loading={loading}
        stableSort={stableSort}
        getComparator={getComparator}
        order={order}
        orderBy={orderBy}
        page={isPage}
        rowsPerPage={rowsPerPage}
        isSelected={isSelected}
        handleClick={handleClick}
        isCheckbox={isCheckbox}
        handleNoteRequest={handleNoteRequest}
      />
    );
  }, [
    data,
    loading,
    order,
    orderBy,
    isPage,
    rowsPerPage,
    isSelected,
    handleClick,
    isCheckbox,
    handleNoteRequest,
  ]);
}

export default MemoizedList;
